import { render, staticRenderFns } from "./VesselMaster.vue?vue&type=template&id=56a314b4&scoped=true&"
import script from "./VesselMaster.vue?vue&type=script&lang=js&"
export * from "./VesselMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a314b4",
  null
  
)

export default component.exports